module.exports = __webpack_public_path__ + "static/media/twitter.d7925a17.svg";